module.exports = __webpack_public_path__ + "static/media/logo.527408c0.png";